import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { slugify } from '../../utils';
import Carousel from '../carousel/Carousel';
import { useMediumUpBp } from '../../hooks/useMedia';

import moreWhiteArrow from '../../../content/media-library/icons/more-white-arrow.svg';

const ImageBlock = (image) => {
  const componentClasses = classNames('image-blocks__item', {
    [`image-blocks__item--${image.itemSize}`]: image.itemSize
  });

  return (
    <div className={componentClasses}>
      <LazyLoadImage src={image.src} alt={image.alt} className="image-blocks__image" />
      {image.overlay ? (
        <a href={image.overlay.linkUrl} target="_blank" rel="noopener noreferrer">
          <p>
            {image.overlay.heading}
            <span className="image-blocks__arrow">
              <img alt="arrow-right" src={moreWhiteArrow} />
            </span>
          </p>
          <p>{image.overlay.body}</p>
        </a>
      ) : null}
    </div>
  );
};

const ImageBlocks = ({ title, images, customPadding, columnTwoWidth, columnThreeWidth, sectionId }) => {
  const isMediumUp = useMediumUpBp();
  const componentClasses = classNames('image-blocks', {
    [`image-blocks--padding-${customPadding}`]: customPadding
  });

  const column2Classes = classNames('image-blocks__block', {
    [`image-blocks__block--${columnTwoWidth}`]: columnTwoWidth
  });

  const column3Classes = classNames('image-blocks__block', {
    [`image-blocks__block--${columnThreeWidth}`]: columnThreeWidth
  });

  const CarouselSlides = images
    .map((image) => {
      if (image.mobileHide) return null;
      return image.overlay ? (
        <a
          key={slugify(image.alt)}
          href={image.overlay.linkUrl}
          className="image-blocks--carousel-link"
          target="_blank"
          rel="noopener noreferrer"
        >
          <LazyLoadImage src={image.sliderSrc} alt={image.alt} className="image-blocks__image" />
          <div>
            <p>{image.overlay.heading}</p>
            <p>{image.overlay.body}</p>
          </div>
        </a>
      ) : (
        <LazyLoadImage key={slugify(image.alt)} src={image.sliderSrc} alt={image.alt} className="image-blocks__image" />
      );
    })
    .filter((image) => image);

  return isMediumUp ? (
    <div className={componentClasses}>
      <div className="image-blocks__block">
        {ImageBlock(images[0])}
        {ImageBlock(images[1])}
      </div>
      <div className={column2Classes}>
        {ImageBlock(images[2])}
        {title ? (
          <div className="image-blocks__item image-blocks__item--small">
            <h2 className="image-blocks__title">{title}</h2>
          </div>
        ) : null}
        {images[3] ? ImageBlock(images[3]) : null}
      </div>

      {images[4] ? <div className={column3Classes}>{ImageBlock(images[4])}</div> : null}
    </div>
  ) : (
    <div className="image-b-carousel" id={sectionId ? sectionId : ''}>
      <Carousel options={{ slidesToShow: 1, centerMode: true, centerPadding: '20px' }} slides={CarouselSlides} />
    </div>
  );
};

ImageBlocks.propTypes = {
  title: PropTypes.string,
  sectionId: PropTypes.string,
  customPadding: PropTypes.string,
  columnTwoWidth: PropTypes.string,
  columnThreeWidth: PropTypes.string,
  titleColour: PropTypes.arrayOf(
    PropTypes.shape({
      src: PropTypes.string,
      alt: PropTypes.string,
      itemSize: PropTypes.string,
      overlay: PropTypes.shape({
        heading: PropTypes.string,
        body: PropTypes.string,
        linkUrl: PropTypes.string
      })
    })
  )
};

export default ImageBlocks;
